import { render, staticRenderFns } from "./LayOut.vue?vue&type=template&id=2034f62a&scoped=true"
import script from "./LayOut.vue?vue&type=script&lang=js"
export * from "./LayOut.vue?vue&type=script&lang=js"
import style0 from "./LayOut.vue?vue&type=style&index=0&id=2034f62a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2034f62a",
  null
  
)

export default component.exports